import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppModuleDetailsPage } from './app-module-details';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppModuleDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppModuleDetailsPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppModuleDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-module-details/app-module-details.module.ts